import { IPersonalInfo } from '../../providers/AcquisitionProvider/models';

export default class AcquisitionErrorToggleEvent extends Event {
    public static EventName = 'acquisitionErrorToggle' as const;

    personalInformation: Partial<IPersonalInfo>;

    constructor(dispatchingPersonalInformation: Partial<IPersonalInfo>) {
        super(
            AcquisitionErrorToggleEvent.EventName, 
            {
                cancelable: false,
                bubbles: false,
                composed: true, // This event is intended to be created by the Application CTA submission
            },
        );
        this.personalInformation = dispatchingPersonalInformation;
    }

    public getValue(string: keyof IPersonalInfo) {
        const fetchedEntry = this.personalInformation[string] as {value?: string, valid?: boolean};
        return fetchedEntry && fetchedEntry?.value ? fetchedEntry.value : '';
    }
}